// src/utils/toastUtils.js
import { toast } from "react-toastify";
import "../../styles/toastUtils.css";

// Custom toast specifically for notifying users about processing started
// Update in src/utils/toastUtils.js
export const showProcessingStartedToast = (message) => {
  toast(message, {
    position: "top-center",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: "processing-started-toast",
    style: {
      fontSize: "16px",
      maxWidth: "500px", // More consistent with permission toast
      fontWeight: "500",
      backgroundColor: "#f0f7ff", // Light blue background (more subtle)
      borderLeft: "5px solid #4caf50", // More muted green border
      color: "#333",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      textAlign: "left",
    },
    icon: "✓", // Checkmark instead of phone emoji
  });
};

// You can keep your regular success toast for other notifications
export const showSuccessToast = (message) => {
  toast.success(message, {
    position: "bottom-right", // Your default position
    autoClose: 5000,
  });
};

export const showPermissionRequestToast = (message) => {
  return toast.info(message, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: "permission-request-toast",
    style: {
      fontSize: "16px",
      maxWidth: "500px",
      fontWeight: "500",
      backgroundColor: "#f0f8ff",
      borderLeft: "5px solid #4285F4",
      color: "#333",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      textAlign: "left", // Added to ensure left alignment
    },
    icon: "🔒",
  });
};
